import React from 'react';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useIntl } from 'react-intl';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import {
  BarcodeContainer,
  BarcodeCopyButton,
  BarcodeString,
  BarcodeStringTitle,
  BarcodeWrapper,
} from './styled';

interface IQRTextProps {
  barcode: string;
}

export const QRText = ({ barcode }: IQRTextProps) => {
  const enableBarcodeCopyToClipboard = useFlag(
    LaunchDarklyFlag.ENABLE_TH_LOYALTY_BARCODE_COPY_TO_CLIPBOARD
  );
  const { formatMessage } = useIntl();

  if (!enableBarcodeCopyToClipboard || !barcode) {
    return null;
  }

  return (
    <BarcodeWrapper>
      <BarcodeStringTitle>QR Code String:</BarcodeStringTitle>
      <BarcodeContainer>
        <BarcodeString readOnly>{barcode}</BarcodeString>
        <CopyToClipboard text={barcode}>
          <BarcodeCopyButton>{formatMessage({ id: 'copy' })}</BarcodeCopyButton>
        </CopyToClipboard>
      </BarcodeContainer>
    </BarcodeWrapper>
  );
};

export default QRText;
